<template>
  <v-app id="inspire" >
    <v-app-bar
      app
      color="blue darken-3"
      dark
      class="hidden-print-only"
    >
      <v-toolbar-title class="ml-0 pl-4">
        <span class="hidden-sm-and-down">Fleet tracking and monitoring</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn small color="primary" v-if='authenticated' v-on:click='logout'>Logout</v-btn>
      <v-btn small color="primary" v-else v-on:click='login'>Login</v-btn> -->
    </v-app-bar>
    <v-content>
      <v-container :key="$route.path" class="fluid">
        <!-- The router view displays the components as the user click router links -->
        <router-view/>
      </v-container>
      <!-- Footer -->
      <v-footer class="font-weight-medium">
        <v-col class="text-center hidden-print-only" cols="12">
          &copy;2010 - {{ new Date().getFullYear() }} | <strong>GPS Tracker</strong> | Valer BOCAN, PhD, CSSLP
        </v-col>
      </v-footer>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    props: {
      source: String,
    },
    data: () => ({
      authenticated: false,
    }),
    created () { this.isAuthenticated() },
    watch: {
    // Everytime the route changes, check for auth status
    '$route': 'isAuthenticated'
    },
    methods: {
      async isAuthenticated () {
        this.authenticated = await this.$auth.isAuthenticated()
      },
      login () {
        this.$auth.loginRedirect('/')
      },
      async logout () {
        await this.$auth.logout();
        await this.isAuthenticated();
        if (this.$route.path !== '/') this.$router.push({ path: '/' })
      }
    }
  }
</script>